import React, { useState, useEffect, useRef } from 'react';
import './ImageSlider.css';

const ImageSlider = ({ slides, autoSlideInterval = 6000 }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isMobileView, setIsMobileView] = useState(false);
    const autoSlideRef = useRef();

    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(window.innerWidth <= 480);
        };

        handleResize(); // Initial check
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        autoSlideRef.current = goToNext;
    });

    useEffect(() => {
        const play = () => {
            autoSlideRef.current();
        };

        const interval = setInterval(play, autoSlideInterval);
        return () => clearInterval(interval);
    }, [currentIndex, autoSlideInterval]);

    const sliderStyles = {
        height: '100%',
        position: 'relative',
    };

    const slideStyles = {
        width: '100%',
        height: '100%',
        borderRadius: '20px',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        // boxShadow: '0px 0px 10px 0px #1c1c1c3f',
    };

    const leftArrowStyles = {
        position: 'absolute',
        top: '50%',
        transform: 'translate(0, -50%)',
        left:'32px',
        fontSize: '45px',
        color:'#fff',
        zIndex: 1,
        cursor:'pointer',
    };

    const rightArrowStyles = {
        position: 'absolute',
        top: '50%',
        transform: 'translate(0, -50%)',
        right:'32px',
        fontSize: '45px',
        color:'#fff',
        zIndex: 1,
        cursor:'pointer',
    };

    const dotsContainerStyles = {
        display:'flex',
        justifyContent:'center',
    };

    const dotStyles = {
        margin: '0 3px',
        cursor:'pointer',
        fontSize:'20px',
    };

    const goToPrevious = () => {
        const isFirstSlide = currentIndex === 0;
        const newIndex = isFirstSlide ? slides.length - 1 : currentIndex - 1;
        setCurrentIndex(newIndex);
    };

    const goToNext = () => {
        const isLastSlide = currentIndex === slides.length - 1;
        const newIndex = isLastSlide ? 0 : currentIndex + 1;
        setCurrentIndex(newIndex);
    };

    const goToSlide = (slideIndex) => {
        setCurrentIndex(slideIndex);
    };

    const getFileType = (url) => {
        if (!url) {
            return 'unknown';
        }
        const extension = url.split('.').pop();
        switch(extension) {
            case 'jpg':
            case 'jpeg':
            case 'png':
            case 'gif':
            case 'webp':
            case 'svg':
            case 'avif':
                return 'image';
            case 'mp4':
            case 'avi':
            case 'mov':
                return 'video';
            default:
                return 'unknown';
        }
    };

    const renderSlide = (slideUrl) => {
        const fileType = getFileType(slideUrl);
        if (fileType === 'image') {
            return <div style={{...slideStyles, backgroundImage: `url(${slideUrl})`}}></div>;
        } else if (fileType === 'video') {
            return (
                <video autoPlay loop muted style={slideStyles}>
                    <source src={slideUrl} type="video/mp4" />
                </video>
            );
        } else {
            return <div>Unsupported file type</div>;
        }
    };

    return (
        <div style={sliderStyles}>
            {(slides.length > 1) && 
            <div style={leftArrowStyles} onClick={goToPrevious}>
                <svg
                    fill="#d89f56"
                    height="24px"
                    width="24px"
                    version="1.1"
                    id="Layer_1"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 330 330"
                >
                    <path
                    id="XMLID_6_"
                    d="M165,0C74.019,0,0,74.019,0,165s74.019,165,165,165s165-74.019,165-165S255.981,0,165,0z M205.606,234.394
                        c5.858,5.857,5.858,15.355,0,21.213C202.678,258.535,198.839,260,195,260s-7.678-1.464-10.606-4.394l-80-79.998
                        c-2.813-2.813-4.394-6.628-4.394-10.606c0-3.978,1.58-7.794,4.394-10.607l80-80.002c5.857-5.858,15.355-5.858,21.213,0
                        c5.858,5.857,5.858,15.355,0,21.213l-69.393,69.396L205.606,234.394z"
                    />
                </svg>
            </div>}
            {(slides.length > 1) && 
            <div style={rightArrowStyles} onClick={goToNext}>
                <svg
                    fill="#d89f56"
                    height="24px"
                    width="24px"
                    version="1.1"
                    id="Layer_1"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 330 330"
                >
                    <path
                    id="XMLID_2_"
                    d="M165,0C74.019,0,0,74.019,0,165s74.019,165,165,165s165-74.019,165-165S255.981,0,165,0z M225.606,175.605
                        l-80,80.002C142.678,258.535,138.839,260,135,260s-7.678-1.464-10.606-4.394c-5.858-5.857-5.858-15.355,0-21.213l69.393-69.396
                        l-69.393-69.392c-5.858-5.857-5.858-15.355,0-21.213c5.857-5.858,15.355-5.858,21.213,0l80,79.998
                        c2.814,2.813,4.394,6.628,4.394,10.606C230,168.976,228.42,172.792,225.606,175.605z"
                    />
                </svg>
            </div>}
            {renderSlide(slides[currentIndex])}
            {(slides.length > 1) && <div style={dotsContainerStyles}>
                {slides.map((slide, slideIndex) => (
                    <div key={slideIndex} style={dotStyles} onClick={() => goToSlide(slideIndex)}>
                        <img 
                            src={slide}
                            alt='product'
                            className={`w-12 h-12 object-cover rounded-xl mt-2 mx-1 ${slideIndex === currentIndex ? 'border-2 border-gray-300' : ''}`}
                        />
                    </div>
                ))}
            </div>}
        </div>
    );
};

export default ImageSlider;
